module.exports = __webpack_public_path__ + "static/img/Select-active.3a056613.svg";